import { render } from "./CustomerOrder.vue?vue&type=template&id=0c0bbd3e"
import script from "./CustomerOrder.vue?vue&type=script&lang=js"
export * from "./CustomerOrder.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__